import React, { useEffect, useState } from "react";
import DashboardLayout from "@/components/lingo/DashboardLayout";
import api from "@/lib/api";
import { Trophy } from "lucide-react";

export default function Leaderboard() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/analytics/leaderboard").then((r) => setItems(r.data)); }, []);
  return (
    <DashboardLayout title="Leaderboard">
      <div className="bg-white border border-slate-200 rounded-3xl p-6 max-w-2xl">
        <div className="space-y-2">
          {items.map((u, i) => (
            <div key={i} data-testid={`leader-${i}`} className={`flex items-center justify-between p-3 rounded-xl ${u.is_me ? "bg-[#FFF4E5] border border-[#F77F00]/40" : "border border-slate-100"}`}>
              <div className="flex items-center gap-4">
                <div className="font-mono w-6 text-slate-400">#{i + 1}</div>
                <div className="w-9 h-9 rounded-full bg-gradient-to-br from-[#003049] to-[#0C4B66] flex items-center justify-center text-sm">{u.name?.[0]}</div>
                <div>
                  <div className="font-medium">{u.name}{u.is_me && <span className="ml-2 text-xs text-[#F77F00]">(you)</span>}</div>
                  <div className="text-xs text-slate-400">{u.test_type?.replaceAll("_", " ")}</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <Trophy className="w-4 h-4 text-amber-400" />
                <span className="font-mono">{u.xp}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </DashboardLayout>
  );
}
